// Seed data for the salon SaaS prototype - no backend; loaded into localStorage on first run.

export const THEMES = {
    vintage: {
        id: "vintage",
        name: "Vintage Club",
        tagline: "Tradição, navalha e couro autêntico.",
        primary: "#d97706",
        headingFont: "Cinzel",
        bodyFont: "Plus Jakarta Sans",
        slogans: [
            "Onde toda barba conta uma história.",
            "Navalha quente, cliente eterno.",
            "Tradição em cada fio.",
            "Whisky, toalha quente e estilo.",
        ],
        backdrop: "leather-texture",
    },
    neon: {
        id: "neon",
        name: "Neon Cyber Cut",
        tagline: "O futuro do degradê chegou.",
        primary: "#d946ef",
        headingFont: "Space Grotesk",
        bodyFont: "Space Grotesk",
        slogans: [
            "Drop fade. Drop the bass. Drop in.",
            "Urban. Bold. Neon.",
            "Tech-cuts for the new generation.",
            "Você dropa o estilo. A gente entrega o brilho.",
        ],
        backdrop: "neon-texture",
    },
    organic: {
        id: "organic",
        name: "Organic Hair Lab",
        tagline: "Beleza natural, ciência botânica.",
        primary: "#10b981",
        headingFont: "Instrument Serif",
        bodyFont: "Inter",
        slogans: [
            "Conectada à natureza. Inspirada em você.",
            "Cabelo saudável, alma leve.",
            "Wellness. Plant-based. Premium.",
            "Cuide do mundo cuidando de você.",
        ],
        backdrop: "organic-texture",
    },
    onyx: {
        id: "onyx",
        name: "Onyx Executive",
        tagline: "Sofisticação corporativa para grooming masculino premium.",
        primary: "#94a3b8",
        headingFont: "Cormorant Garamond",
        bodyFont: "Inter",
        slogans: [
            "Onde executivos se tornam ícones.",
            "Discrição é o novo luxo.",
            "Sua imagem, nosso ofício.",
            "Refinamento sem alarde.",
        ],
        backdrop: "onyx-texture",
    },
    minimal: {
        id: "minimal",
        name: "Pure Minimal",
        tagline: "Menos é mais. Foco no essencial.",
        primary: "#f5f5f5",
        headingFont: "Inter",
        bodyFont: "Inter",
        slogans: [
            "Beleza sem ruído.",
            "Simples. Limpo. Você.",
            "O essencial em alta resolução.",
            "Tudo o que importa, nada além.",
        ],
        backdrop: "minimal-texture",
    },
    editorial: {
        id: "editorial",
        name: "Studio Editorial",
        tagline: "Estética de revista, tratamento de capa.",
        primary: "#fbbf24",
        headingFont: "Playfair Display",
        bodyFont: "Inter",
        slogans: [
            "Saia daqui como modelo de editorial.",
            "Cada visita, uma editorial.",
            "Cabelo de capa, atitude de marca.",
            "Onde estilo vira manifesto.",
        ],
        backdrop: "editorial-texture",
    },
};

export const LOGO_ICONS = [
    { id: "scissors", icon: "fa-scissors", label: "Tesoura" },
    { id: "spray", icon: "fa-spray-can-sparkles", label: "Spray" },
    { id: "beard", icon: "fa-user-tie", label: "Estilo" },
    { id: "wand", icon: "fa-wand-magic-sparkles", label: "Mágica" },
    { id: "crown", icon: "fa-crown", label: "Coroa" },
    { id: "leaf", icon: "fa-leaf", label: "Folha" },
];

export const IMAGE_GALLERY = {
    vintage: [
        "https://images.unsplash.com/photo-1778676688264-2a5db8886ab3?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1628274459813-74bc7e2c53b2?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    ],
    neon: [
        "https://images.unsplash.com/photo-1637777277337-f114350fb088?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1535637603896-07c179d71103?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1622286342621-4bd786c2447c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    ],
    organic: [
        "https://images.unsplash.com/photo-1703792686756-c82bf734c89b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.pexels.com/photos/27165074/pexels-photo-27165074.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        "https://images.unsplash.com/photo-1560066984-138dadb4c035?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    ],
    onyx: [
        "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1622286342621-4bd786c2447c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    ],
    minimal: [
        "https://images.unsplash.com/photo-1560066984-138dadb4c035?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1778676688264-2a5db8886ab3?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1628274459813-74bc7e2c53b2?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    ],
    editorial: [
        "https://images.unsplash.com/photo-1535637603896-07c179d71103?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1637777277337-f114350fb088?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
        "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    ],
};

export const DEFAULT_SERVICES = [
    { id: "s1", name: "Corte Clássico", price: 65, duration: 30, icon: "fa-scissors", category: "Cabelo", active: true, commission: 45 },
    { id: "s2", name: "Corte + Barba", price: 95, duration: 50, icon: "fa-user", category: "Combos", active: true, commission: 50 },
    { id: "s3", name: "Barba Terapia", price: 55, duration: 30, icon: "fa-mustache", category: "Barba", active: true, commission: 40 },
    { id: "s4", name: "Pigmentação", price: 120, duration: 60, icon: "fa-palette", category: "Tratamento", active: true, commission: 35 },
    { id: "s5", name: "Hidratação", price: 80, duration: 40, icon: "fa-droplet", category: "Tratamento", active: true, commission: null },
    { id: "s6", name: "Sobrancelha", price: 30, duration: 15, icon: "fa-eye", category: "Estética", active: true, commission: null },
    { id: "s7", name: "Platinado", price: 250, duration: 120, icon: "fa-wand-magic-sparkles", category: "Cabelo", active: true, commission: 30 },
    { id: "s8", name: "Relax Capilar", price: 110, duration: 45, icon: "fa-spa", category: "Tratamento", active: true, commission: null },
];

export const DEFAULT_PRODUCTS = [
    { id: "p1", name: "Pomada Modeladora", price: 45, stock: 32, minStock: 10, icon: "fa-jar", category: "Cuidados", active: true, commission: 10 },
    { id: "p2", name: "Cerveja Long Neck", price: 12, stock: 80, minStock: 24, icon: "fa-beer-mug-empty", category: "Bebidas", active: true, commission: 5 },
    { id: "p3", name: "Shampoo Premium", price: 89, stock: 4, minStock: 8, icon: "fa-bottle-droplet", category: "Cuidados", active: true, commission: 15 },
    { id: "p4", name: "Óleo p/ Barba", price: 55, stock: 25, minStock: 10, icon: "fa-prescription-bottle", category: "Cuidados", active: true, commission: 12 },
    { id: "p5", name: "Whisky Dose", price: 28, stock: 40, minStock: 12, icon: "fa-whiskey-glass", category: "Bebidas", active: true, commission: null },
    { id: "p6", name: "Energético", price: 14, stock: 6, minStock: 12, icon: "fa-bolt", category: "Bebidas", active: true, commission: null },
];

export const SERVICE_CATEGORIES = ["Cabelo", "Barba", "Combos", "Tratamento", "Estética", "Outros"];
export const PRODUCT_CATEGORIES = ["Cuidados", "Bebidas", "Acessórios", "Marca Própria", "Outros"];

export const ICON_OPTIONS = [
    "fa-scissors", "fa-user", "fa-mustache", "fa-palette", "fa-droplet",
    "fa-eye", "fa-wand-magic-sparkles", "fa-spa", "fa-jar", "fa-beer-mug-empty",
    "fa-bottle-droplet", "fa-prescription-bottle", "fa-whiskey-glass", "fa-bolt",
    "fa-leaf", "fa-spray-can-sparkles", "fa-crown", "fa-fire", "fa-star",
];

// Gera agendamentos centrais (fonte única) para todos os profissionais
// Cobertura: -21 a +42 dias (3 semanas passadas, 6 semanas futuras)
export const seedAppointments = (professionals, clients, services) => {
    const list = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const STATUSES = ["agendado", "concluido", "em-andamento"];

    professionals.forEach((pro) => {
        const proSeed = pro.id.charCodeAt(3) || 0;
        for (let offset = -21; offset <= 42; offset++) {
            const day = new Date(today.getTime() + offset * 86400000);
            const weekday = day.getDay();
            if (weekday === 0) continue; // domingo sem agenda

            const seedVal = proSeed + offset;
            const count = 2 + (Math.abs(seedVal) % 4); // 2-5 appts/dia

            for (let k = 0; k < count; k++) {
                const hour = 9 + ((seedVal * 3 + k * 2) % 9); // 9h..17h
                const min = (k % 2) * 30;
                const apptDate = new Date(day);
                apptDate.setHours(hour, min, 0, 0);

                // Pick service (only active services)
                const activeServices = services.filter((s) => s.active);
                const svc = activeServices[Math.abs(seedVal * 5 + k * 3) % activeServices.length];

                // Pick client (random from clients)
                const cli = clients[Math.abs(seedVal * 7 + k * 11) % clients.length];

                // Status by offset
                let status;
                if (offset < 0) status = "concluido";
                else if (offset === 0 && hour < new Date().getHours()) status = "concluido";
                else status = "agendado";

                const startedAt = status === "concluido" ? apptDate.getTime() : null;
                const finishedAt = status === "concluido" ? apptDate.getTime() + svc.duration * 60000 : null;

                list.push({
                    id: `appt-${pro.id}-${offset}-${k}`,
                    date: apptDate.getTime(),
                    time: `${String(hour).padStart(2, "0")}:${String(min).padStart(2, "0")}`,
                    duration_min: svc.duration || 30,
                    estimated_end: apptDate.getTime() + (svc.duration || 30) * 60000,
                    clientId: cli.id,
                    clientName: cli.name,
                    professionalId: pro.id,
                    professionalName: pro.name,
                    serviceId: svc.id,
                    serviceName: svc.name,
                    servicePrice: svc.price,
                    status,
                    started_at: startedAt,
                    finished_at: finishedAt,
                    source: "agenda",
                    notes: "",
                });
            }
        }
    });
    return list;
};

// === LEGACY (mantido para compat) ===
// Gera agenda mock para um profissional cobrindo ~6 semanas
const seedAgendaFor = (proId) => {
    const services = ["Corte Clássico", "Corte + Barba", "Barba Terapia", "Pigmentação", "Hidratação", "Platinado", "Sobrancelha"];
    const clientsList = ["Bruno Lima", "Caio Mendes", "Diego Soares", "Eduardo Reis", "Fábio Carvalho", "Mariana Costa", "Ana Beatriz", "Lucas Andrade", "Pedro Henrique", "Rodrigo Pinto"];
    const statuses = ["agendado", "concluido", "em-andamento"];
    const list = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    // Generate appointments from -21 to +42 days (3 weeks past, 6 weeks future)
    for (let offset = -21; offset <= 42; offset++) {
        const day = new Date(today.getTime() + offset * 86400000);
        const weekday = day.getDay();
        if (weekday === 0) continue; // domingo sem agenda
        const seed = (proId.charCodeAt(3) || 0) + offset;
        const count = 2 + (Math.abs(seed) % 4); // 2-5 appts/dia
        for (let k = 0; k < count; k++) {
            const hour = 9 + ((seed * 3 + k * 2) % 9); // 9h..17h
            const min = (k % 2) * 30;
            const apptDate = new Date(day);
            apptDate.setHours(hour, min, 0, 0);
            const statusIdx = offset < -1 ? 1 : offset === 0 && hour < new Date().getHours() ? 2 : 0;
            list.push({
                id: `appt-${proId}-${offset}-${k}`,
                date: apptDate.getTime(),
                time: `${String(hour).padStart(2, "0")}:${String(min).padStart(2, "0")}`,
                client: clientsList[Math.abs(seed * 7 + k * 11) % clientsList.length],
                service: services[Math.abs(seed * 5 + k * 3) % services.length],
                status: statuses[statusIdx],
            });
        }
    }
    return list;
};

// Gera histórico mock de vendas dos últimos 60 dias por profissional (demo)
const seedTransactionsFor = (proId, baseRate) => {
    const services = [
        { name: "Corte Clássico", price: 65, commission: 45 },
        { name: "Corte + Barba", price: 95, commission: 50 },
        { name: "Barba Terapia", price: 55, commission: 40 },
        { name: "Pigmentação", price: 120, commission: 35 },
        { name: "Hidratação", price: 80, commission: null },
        { name: "Platinado", price: 250, commission: 30 },
    ];
    const clients = [
        "Bruno Lima", "Caio Mendes", "Diego Soares", "Eduardo Reis",
        "Fábio Carvalho", "Mariana Costa", "Ana Beatriz", "Lucas Andrade",
        "Pedro Henrique", "Rodrigo Pinto", "Camila Vidal", "Thiago Rocha",
    ];
    const list = [];
    const now = Date.now();
    // Generate ~3-5 transactions per day for last 60 days
    for (let d = 0; d < 60; d++) {
        const count = 3 + ((proId.charCodeAt(3) + d) % 3);
        for (let k = 0; k < count; k++) {
            const svc = services[(d * 7 + k * 3 + proId.length) % services.length];
            const client = clients[(d * 11 + k * 5 + proId.length) % clients.length];
            const rate = svc.commission ?? Math.round(baseRate * 100);
            const total = svc.price;
            const share = +(total * (rate / 100)).toFixed(2);
            list.push({
                id: `txn-${proId}-${d}-${k}`,
                date: now - d * 86400000 - k * 3600000,
                service: svc.name,
                client,
                total,
                rate,
                share,
            });
        }
    }
    return list;
};

export const DEFAULT_PROFESSIONALS = [
    {
        id: "pro1",
        name: "Mateus Alencar",
        role: "Barbeiro Master",
        phone: "(11) 98765-4321",
        pixKey: "mateus.alencar@email.com",
        commissionRate: 0.45,
        fixedSalary: { active: false, value: 0 },
        commission: { active: true, rate: 45 },
        commissionAccrued: 1245.5,
        active: true,
        avatar: "https://i.pravatar.cc/200?img=12",
        agenda: seedAgendaFor("pro1"),
        transactions: seedTransactionsFor("pro1", 0.45),
    },
    {
        id: "pro2",
        name: "Renata Vilas",
        role: "Cabeleireira Senior",
        phone: "(11) 99888-1122",
        pixKey: "11999881122",
        commissionRate: 0.5,
        fixedSalary: { active: true, value: 1800 },
        commission: { active: true, rate: 50 },
        commissionAccrued: 1890.2,
        active: true,
        avatar: "https://i.pravatar.cc/200?img=44",
        agenda: seedAgendaFor("pro2"),
        transactions: seedTransactionsFor("pro2", 0.5),
    },
    {
        id: "pro3",
        name: "João Pedrosa",
        role: "Barbeiro",
        phone: "(21) 97766-3344",
        pixKey: "123.456.789-00",
        commissionRate: 0.4,
        fixedSalary: { active: false, value: 0 },
        commission: { active: true, rate: 40 },
        commissionAccrued: 756.8,
        active: true,
        avatar: "https://i.pravatar.cc/200?img=33",
        agenda: seedAgendaFor("pro3"),
        transactions: seedTransactionsFor("pro3", 0.4),
    },
    {
        id: "pro4",
        name: "Pedro Soare",
        role: "Barbeiro",
        phone: "(11) 91234-5678",
        pixKey: "pedro@pix.com",
        commissionRate: 0.35,
        fixedSalary: { active: false, value: 0 },
        commission: { active: true, rate: 35 },
        commissionAccrued: 420.5,
        active: true,
        avatar: "https://i.pravatar.cc/200?img=12",
        agenda: [],
        transactions: [],
    },
    {
        id: "pro5",
        name: "Tafarel Goleiro",
        role: "Barbeiro Junior",
        phone: "(31) 92345-6789",
        pixKey: "tafa@pix.com",
        commissionRate: 0.3,
        fixedSalary: { active: false, value: 0 },
        commission: { active: true, rate: 30 },
        commissionAccrued: 230.0,
        active: true,
        avatar: "https://i.pravatar.cc/200?img=58",
        agenda: [],
        transactions: [],
    },
    {
        id: "pro6",
        name: "Ana Maria",
        role: "Cabeleireira",
        phone: "(41) 93456-7890",
        pixKey: "ana@pix.com",
        commissionRate: 0.45,
        fixedSalary: { active: false, value: 0 },
        commission: { active: true, rate: 45 },
        commissionAccrued: 612.4,
        active: true,
        avatar: "https://i.pravatar.cc/200?img=49",
        agenda: [],
        transactions: [],
    },
    {
        id: "pro7",
        name: "Carlos Vieira",
        role: "Barbeiro",
        phone: "(51) 94567-8901",
        pixKey: "carlos@pix.com",
        commissionRate: 0.4,
        fixedSalary: { active: false, value: 0 },
        commission: { active: true, rate: 40 },
        commissionAccrued: 380.9,
        active: true,
        avatar: "https://i.pravatar.cc/200?img=68",
        agenda: [],
        transactions: [],
    },
    {
        id: "pro8",
        name: "Juliana Reis",
        role: "Manicure",
        phone: "(61) 95678-9012",
        pixKey: "juli@pix.com",
        commissionRate: 0.5,
        fixedSalary: { active: false, value: 0 },
        commission: { active: true, rate: 50 },
        commissionAccrued: 270.0,
        active: true,
        avatar: "https://i.pravatar.cc/200?img=44",
        agenda: [],
        transactions: [],
    },
];

const randomNames = [
    "Ana Beatriz", "Lucas Andrade", "Pedro Henrique", "Mariana Costa",
    "Felipe Tavares", "Júlia Ramos", "Gabriel Marques", "Larissa Souza",
    "Rodrigo Pinto", "Camila Vidal", "Thiago Rocha", "Beatriz Lemos",
];
export const getRandomClientName = () =>
    randomNames[Math.floor(Math.random() * randomNames.length)];

export const DEFAULT_COMANDAS = [
    {
        id: "c1",
        client: "Bruno Lima",
        professional: "pro1",
        items: [
            { ...DEFAULT_SERVICES[1], qty: 1, kind: "service" },
            { ...DEFAULT_PRODUCTS[0], qty: 1, kind: "product" },
        ],
        createdAt: Date.now() - 1000 * 60 * 45,
        status: "open",
    },
    {
        id: "c2",
        client: "Mariana Costa",
        professional: "pro2",
        items: [{ ...DEFAULT_SERVICES[6], qty: 1, kind: "service" }],
        createdAt: Date.now() - 1000 * 60 * 20,
        status: "open",
    },
];

export const WEEKLY_SALES = [
    { day: "Seg", services: 2100, products: 480 },
    { day: "Ter", services: 2680, products: 520 },
    { day: "Qua", services: 1950, products: 410 },
    { day: "Qui", services: 3120, products: 720 },
    { day: "Sex", services: 4280, products: 980 },
    { day: "Sáb", services: 5640, products: 1340 },
    { day: "Dom", services: 1280, products: 220 },
];

export const DEFAULT_BRAND = {
    shopId: "salaovintage",
    shopName: "Salão Vintage Club",
    bannerTitle: "Cortes que atravessam gerações",
    bannerSubtitle: "Tradição em cada fio. Whisky, toalha quente e estilo.",
    logoIcon: "scissors",
    primaryColor: "#d97706",
    themeId: "vintage",
    heroImage: "https://images.unsplash.com/photo-1778676688264-2a5db8886ab3?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    totemImages: [
        "https://images.unsplash.com/photo-1778676688264-2a5db8886ab3?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
        "https://images.unsplash.com/photo-1628274459813-74bc7e2c53b2?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
        "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    ],
    totemHeadline: "Bem-vindo ao Vintage Club",
    totemSubhead: "Reserve seu horário e viva uma experiência inesquecível.",
    customDomain: "",
    customDomainStatus: "idle", // idle | checking | active
    financialPin: "1234",
    kioskPin: "2580",
    // Dados cadastrais (para o módulo "Cadastro" do tenant)
    ownerKind: "PJ", // PF | PJ
    ownerDocument: "12.345.678/0001-99",
    ownerName: "João Pereira da Silva",
    responsiblePerson: "Carlos Eduardo Pereira", // PJ: pessoa responsável pelo sistema
    ownerEmail: "dono@salaovintage.com",
    ownerPhone: "(11) 98765-4321",
    // Plano e cobrança
    plan: "Royal",
    nextBillingDate: "2026-03-15",
    paymentMethod: {
        type: "card",
        brand: "Visa",
        last4: "4242",
        holder: "JOAO P SILVA",
        expiry: "12/27",
    },
    billingHistory: [
        { id: "inv-2602", date: "2026-02-15", amount: 297, status: "paid", invoice: "INV-2026-02-15" },
        { id: "inv-2601", date: "2026-01-15", amount: 297, status: "paid", invoice: "INV-2026-01-15" },
        { id: "inv-2512", date: "2025-12-15", amount: 297, status: "paid", invoice: "INV-2025-12-15" },
    ],
};


// Helper to generate a date string for demo (X days from now)
const daysFromNowISO = (offset) => {
    const d = new Date();
    d.setDate(d.getDate() + offset);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const DEFAULT_CLIENTS = [
    {
        id: "61111",
        proId: "pro1",
        name: "André Nome",
        document: "123.456.789-00",
        phone: "(11) 99876-1111",
        email: "andre@email.com",
        birthDate: "1990-04-15",
        address: "Av. Paulista, 1000 - São Paulo",
        notes: "Sempre prefere ser atendido às terças à tarde.",
        preferences: ["Corte Degradê", "Usa pomada matte"],
        allergies: "",
        totalSpent: 2840,
        balance: 1240,
        paymentStatus: "Em Dia",
        lastService: "Corte de Cabelo",
        lastServiceDate: Date.now() - 100 * 86400000,
        lastServiceValue: 65,
        transactions: [
            { id: "t1", date: Date.now() - 100 * 86400000, service: "Corte de Cabelo", value: 65 },
            { id: "t2", date: Date.now() - 115 * 86400000, service: "Corte + Barba", value: 95 },
            { id: "t3", date: Date.now() - 130 * 86400000, service: "Pigmentação", value: 120 },
        ],
        createdAt: Date.now() - 140 * 86400000,
    },
    {
        id: "32222",
        proId: "pro1",
        name: "André Flamoirato",
        document: "987.654.321-11",
        phone: "(11) 99543-2222",
        email: "andre.flamoirato@email.com",
        birthDate: "1985-09-22",
        address: "R. Augusta, 250 - São Paulo",
        notes: "Cliente VIP — faz combo todo mês.",
        preferences: ["Combo mensal", "Whisky on the rocks"],
        allergies: "Alergia a perfumes cítricos.",
        totalSpent: 5460,
        balance: 1300,
        paymentStatus: "Em Dia",
        lastService: "Corte + Barba",
        lastServiceDate: Date.now() - 7 * 86400000,
        lastServiceValue: 95,
        transactions: [
            { id: "t1", date: Date.now() - 7 * 86400000, service: "Corte + Barba", value: 95 },
            { id: "t2", date: Date.now() - 35 * 86400000, service: "Platinado", value: 250 },
        ],
        createdAt: Date.now() - 210 * 86400000,
    },
    {
        id: "03333",
        proId: "pro1",
        name: "Bruno Lima",
        document: "456.789.123-22",
        phone: "(11) 99700-3333",
        email: "bruno.lima@email.com",
        birthDate: "1992-12-03",
        address: "R. Oscar Freire, 88 - São Paulo",
        notes: "",
        preferences: ["Barba fechada"],
        allergies: "",
        totalSpent: 980,
        balance: 480,
        paymentStatus: "Em Dia",
        lastService: "Barba Terapia",
        lastServiceDate: Date.now() - 12 * 86400000,
        lastServiceValue: 55,
        transactions: [
            { id: "t1", date: Date.now() - 12 * 86400000, service: "Barba Terapia", value: 55 },
        ],
        createdAt: Date.now() - 60 * 86400000,
    },
    {
        id: "04444",
        proId: "pro2",
        name: "Mariana Costa",
        document: "321.654.987-33",
        phone: "(21) 99800-4444",
        email: "mariana@email.com",
        birthDate: daysFromNowISO(4),
        address: "R. Visconde de Pirajá, 500 - Rio de Janeiro",
        notes: "Atende preferencialmente aos sábados pela manhã.",
        preferences: ["Hidratação mensal"],
        allergies: "Alergia a amônia.",
        totalSpent: 1750,
        balance: 250,
        paymentStatus: "Atrasado",
        lastService: "Hidratação",
        lastServiceDate: Date.now() - 18 * 86400000,
        lastServiceValue: 80,
        transactions: [
            { id: "t1", date: Date.now() - 18 * 86400000, service: "Hidratação", value: 80 },
        ],
        createdAt: Date.now() - 90 * 86400000,
    },
];

export const DEFAULT_NOTES_BY_PRO = {
    pro1: [
        {
            id: "n1",
            date: Date.now() - 2 * 86400000,
            title: "Reposição de estoque",
            content: "Pedir mais pomada matte na próxima semana. Está chegando ao mínimo.",
        },
        {
            id: "n2",
            date: Date.now() - 5 * 86400000,
            title: "Comunicado",
            content: "Próxima sexta vou chegar 30 min atrasado. Avisar clientes do horário das 9h.",
        },
    ],
    pro2: [],
    pro3: [],
};


// ─── Marketing seed (templates + campaigns) ──────────────────────────────
export const DEFAULT_TEMPLATES = [
    {
        id: "tpl-reativacao-corte",
        name: "Reativação · Corte 45d",
        channel: "whatsapp",
        body: "Oi {cliente_nome}! 👋 Faz {dias_inativo} dias que você não passa aqui no {salao_nome}. Que tal dar um trato no visual? Agende agora: {link_agendamento}",
        variables: ["cliente_nome", "dias_inativo", "salao_nome", "link_agendamento"],
    },
    {
        id: "tpl-reativacao-barba",
        name: "Reativação · Barba 30d",
        channel: "whatsapp",
        body: "E aí {cliente_nome}! ✂️ Já tá na hora daquela barba caprichada. Reserva seu horário com a gente: {link_agendamento}",
        variables: ["cliente_nome", "link_agendamento"],
    },
    {
        id: "tpl-aniversario",
        name: "Aniversariante do Mês",
        channel: "whatsapp",
        body: "🎂 Feliz aniversário, {cliente_nome}! No seu mês, a {servico_nome} é por conta da casa. Vem comemorar com a gente: {link_agendamento}",
        variables: ["cliente_nome", "servico_nome", "link_agendamento"],
    },
    {
        id: "tpl-upsell",
        name: "Up-sell · Tratamento Complementar",
        channel: "whatsapp",
        body: "Oi {cliente_nome}! Pensei em você. Que tal turbinar seu próximo {ultimo_servico} com uma {servico_sugerido}? Tenho horário esta semana: {link_agendamento}",
        variables: ["cliente_nome", "ultimo_servico", "servico_sugerido", "link_agendamento"],
    },
    {
        id: "tpl-nps",
        name: "NPS Pós-Atendimento",
        channel: "whatsapp",
        body: "Oi {cliente_nome}! Foi um prazer te atender hoje. De 1 a 5, como foi a experiência com {profissional_nome}? Sua opinião nos ajuda muito! 🌟",
        variables: ["cliente_nome", "profissional_nome"],
    },
    {
        id: "tpl-indicacao",
        name: "Programa de Indicação",
        channel: "whatsapp",
        body: "{cliente_nome}, agora você tem um código exclusivo: {codigo_indicacao}. Cada amigo que agendar usando seu código te dá R$ 20 de crédito! Compartilha: {link_indicacao}",
        variables: ["cliente_nome", "codigo_indicacao", "link_indicacao"],
    },
];

export const DEFAULT_CAMPAIGNS = [
    {
        id: "cmp-reativacao-corte",
        name: "Chama-Cliente · Cortes 45 dias",
        trigger: { type: "inactive", config: { daysAway: 45, serviceCategory: "Corte" } },
        templateId: "tpl-reativacao-corte",
        active: true,
        createdAt: Date.now() - 30 * 86400000,
        stats: { sent: 24, converted: 9 },
    },
    {
        id: "cmp-reativacao-barba",
        name: "Chama-Cliente · Barba 30 dias",
        trigger: { type: "inactive", config: { daysAway: 30, serviceCategory: "Barba" } },
        templateId: "tpl-reativacao-barba",
        active: true,
        createdAt: Date.now() - 25 * 86400000,
        stats: { sent: 18, converted: 7 },
    },
    {
        id: "cmp-aniversariantes",
        name: "Aniversariantes do Mês",
        trigger: { type: "birthday-month", config: {} },
        templateId: "tpl-aniversario",
        active: true,
        createdAt: Date.now() - 60 * 86400000,
        stats: { sent: 42, converted: 28 },
    },
    {
        id: "cmp-upsell",
        name: "Up-sell · Tratamento Capilar",
        trigger: { type: "upsell", config: { baseService: "Corte Clássico", suggestService: "Hidratação" } },
        templateId: "tpl-upsell",
        active: false,
        createdAt: Date.now() - 10 * 86400000,
        stats: { sent: 0, converted: 0 },
    },
    {
        id: "cmp-nps",
        name: "Pesquisa de Satisfação · NPS",
        trigger: { type: "post-service", config: { delayMin: 60 } },
        templateId: "tpl-nps",
        active: true,
        createdAt: Date.now() - 45 * 86400000,
        stats: { sent: 87, converted: 71 },
    },
];

export const DEFAULT_MESSAGE_LOG = [
    {
        id: "msg-1",
        campaignId: "cmp-aniversariantes",
        clientId: "04444",
        channel: "whatsapp",
        status: "delivered",
        sentAt: Date.now() - 3 * 86400000,
        convertedAt: Date.now() - 1 * 86400000,
    },
    {
        id: "msg-2",
        campaignId: "cmp-reativacao-corte",
        clientId: "61111",
        channel: "whatsapp",
        status: "delivered",
        sentAt: Date.now() - 5 * 86400000,
    },
    {
        id: "msg-3",
        campaignId: "cmp-nps",
        clientId: "03333",
        channel: "whatsapp",
        status: "delivered",
        sentAt: Date.now() - 1 * 86400000,
        feedback: { rating: 5, comment: "Atendimento impecável!" },
    },
    {
        id: "msg-4",
        campaignId: "cmp-nps",
        clientId: "32222",
        channel: "whatsapp",
        status: "delivered",
        sentAt: Date.now() - 2 * 86400000,
        feedback: { rating: 2, comment: "Esperei muito tempo." },
    },
];



// ─── Payables (Contas a Pagar) seed ──────────────────────────────────────
const today = new Date();
const dueDate = (offset) => {
    const d = new Date(today);
    d.setDate(d.getDate() + offset);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
};

export const DEFAULT_PAYABLES = [
    { id: "pay-aluguel", kind: "fixed", description: "Aluguel do ponto comercial", category: "Imóvel", amount: 3500, dueDate: dueDate(2), status: "open", recurring: true, recurrencePeriod: "monthly" },
    { id: "pay-luz", kind: "fixed", description: "Energia elétrica · Enel", category: "Utilidades", amount: 480, dueDate: dueDate(-2), status: "open", recurring: true, recurrencePeriod: "monthly" },
    { id: "pay-agua", kind: "fixed", description: "Água · Sabesp", category: "Utilidades", amount: 180, dueDate: dueDate(8), status: "open", recurring: true, recurrencePeriod: "monthly" },
    { id: "pay-internet", kind: "fixed", description: "Internet 600MB · Vivo Fibra", category: "Utilidades", amount: 199, dueDate: dueDate(5), status: "open", recurring: true, recurrencePeriod: "monthly" },
    { id: "pay-nf-produtos", kind: "variable", description: "NF 4521 · Wahl Pomadas (10un)", category: "Estoque", amount: 350, dueDate: dueDate(-5), paidAt: Date.now() - 4 * 86400000, status: "paid", recurring: false },
    { id: "pay-iss", kind: "fixed", description: "ISS · Prefeitura", category: "Impostos", amount: 245, dueDate: dueDate(12), status: "open", recurring: true, recurrencePeriod: "monthly" },
];
